import type { PropsWithChildren } from 'react';

import { type UploadCommonProps } from '../../Upload'
import { DragDropWrapper } from '@ui/blocks/DragDropWrapper'
import { type IDragDropWrapperProps } from '@ui/blocks/DragDropWrapper/DragDropWrapper'
import { Space } from '@ui/elements/Space'
import { SubText } from '@ui/elements/Text'

export interface IUploadDragDropWrapperProps extends IDragDropWrapperProps {
  commonProps: UploadCommonProps
  innerProps: {
    maxFileSize: string
  }
}

export const UploadDragDropWrapper = ({
  commonProps,
  innerProps = {
    maxFileSize: null,
  },
  ...dragDropWrapperProps
}: PropsWithChildren<IUploadDragDropWrapperProps>) => {
  const { maxFileSize } = innerProps

  return (
    <DragDropWrapper
      analyticsId={commonProps.uploadProps.analyticsIds?.uploadDropzone}
      content={
        <Space size='xsmall' align='center'>
          <SubText>{commonProps.strings.dragDropOverlayInfo}</SubText>
          {!!maxFileSize && <SubText>(max file size {maxFileSize})</SubText>}
        </Space>
      }
      {...dragDropWrapperProps}
    />
  )
}
